import apiClient from './config';

export default {
  // Récupérer tous les programmes de fidélité
  getAllProgrammes() {
    return apiClient.get('/fidelite');
  },

  // Créer un nouveau programme de fidélité
  createProgramme(data) {
    return apiClient.post('/fidelite', data);
  },

  // Modifier un programme de fidélité
  updateProgramme(index, data) {
    return apiClient.put(`/fidelite/${index}`, data);
  },

  // Supprimer un programme de fidélité
  deleteProgramme(index) {
    return apiClient.delete(`/fidelite/${index}`);
  },

  // Activer/désactiver un programme
  toggleProgramme(index) {
    return apiClient.post(`/fidelite/${index}/toggle`);
  }
};
